module.exports = __webpack_public_path__ + "static/media/message-icon.20c8e44b.svg";